(function(){
    'use strict';

    angular.module('elogbooks.user.finance.purchase-invoices', []);
})();
